import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiAlertTriangle } = FiIcons;

function StickyDisclaimer() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const disclaimerClosed = sessionStorage.getItem('disclaimerClosed');
    if (!disclaimerClosed) {
      const timer = setTimeout(() => setIsVisible(true), 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('disclaimerClosed', 'true');
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div 
          initial={{ opacity: 0, y: 50 }} 
          animate={{ opacity: 1, y: 0 }} 
          exit={{ opacity: 0, y: 50 }}
          role="region" 
          aria-live="polite"
          aria-label="Important Disclaimer"
          className="fixed bottom-4 right-4 z-[60] w-full max-w-md bg-gray-900 text-white rounded-lg shadow-2xl border border-gray-700"
        >
          <div className="p-4">
            <div className="flex items-start">
              <div className="flex-shrink-0 pt-0.5">
                <SafeIcon icon={FiAlertTriangle} className="h-5 w-5 text-amber-400" aria-hidden="true" />
              </div>
              <div className="ml-3 w-0 flex-1">
                <p className="text-sm font-bold text-white"> 
                  Regulatory Notice
                </p>
                <p className="text-sm text-gray-300 mt-1 leading-relaxed">
                  Investments in the securities market are subject to market risks. Read all related documents carefully before investing.
                </p>
              </div>
              <div className="ml-2 flex-shrink-0 flex">
                <button 
                  onClick={handleClose} 
                  className="inline-flex bg-gray-800 rounded-md p-1.5 text-gray-400 hover:bg-gray-700 focus:outline-none"
                  aria-label="Dismiss disclaimer"
                >
                  <SafeIcon icon={FiX} className="h-4 w-4" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default StickyDisclaimer;